import { LocalFilterOptions } from 'src/components/organisms';
import { GlobalFilterLocation } from 'src/types';

export const useFormatPdfFilter = (localFilterOptions: LocalFilterOptions) => {
  const locationOption =
    localFilterOptions.selectedLocationFilter ?? GlobalFilterLocation.SITES;
  const selectedLocationOptions =
    locationOption === GlobalFilterLocation.SITES
      ? localFilterOptions.site
      : localFilterOptions.country;

  const timeFrameStart = new Date(localFilterOptions.time?.timeframe.start);
  const timeFrameEnd = new Date(localFilterOptions.time?.timeframe.end);

  const pdfDownloadLocalFilterData = [
    {
      cellData: [
        'Category',
        localFilterOptions.category?.selectedOptions.join(', ') ?? '',
      ],
      row: localFilterOptions.category ?? '',
    },
    {
      cellData: [
        'Department',
        localFilterOptions.department?.selectedOptions.join(', ') ?? '',
      ],
      row: localFilterOptions.department ?? '',
    },
    {
      cellData: [
        'Timeframe',
        `${timeFrameStart ?? ''} - ${timeFrameEnd ?? ''}`,
      ],
      row: localFilterOptions.department ?? '',
    },
    {
      cellData: [
        locationOption === GlobalFilterLocation.SITES ? 'Site' : 'Country',
        selectedLocationOptions?.selectedOptions.join(', ') ?? '',
      ],
      row: selectedLocationOptions ?? '',
    },
  ];

  return pdfDownloadLocalFilterData;
};
